const messages = {
    en: {
        menu: {
            surveyResponses: 'Survey Responses',
            surveys: 'Surveys',
            userdashboard: 'Users Dashboard',
            customization: 'Customization',
            administration: 'Administration',
            products: "Products",
            categories: "Categories",
            ingredients: "Ingredients",
            branches: "Branch",
            cashRegisters: "Cash Registers",
            ordersGeneral: "Orders general",
            orders: "Orders",
            kitchenOrders: "Orders kitchen",
            ovenOrders: "Orders oven",
            deliveryOrders: "Orders delivery",
            barOrders: "Orders bar",
            barAllOrders: "All Orders",
            settings: "Settings",
            orderBar: "Order bar",
            orderCashRegister: "orderCashRegister",
            orderReport: "orderReport",
            arqueoReport: "arqueoReport",
            restartOrder: "restartOrder",
            paymentMethods: 'paymentMethods',
            stock: "Stock",
            stockOperation: "Stock operation",
            stockReport: "Stock report",
            stockTransactionAudit: "Stock audit",
            salesReport: "Sales report",
            manage: 'manage',
            zones: "Zones",
            locations: "Locations",
            localities: "Localities",
            maps: "Maps",
            orderState: "Order States",
            calendar: "Calendar",
            calendarTakeAway: "Calendar Take away",
            calendarDelivery: "Calendar Delivery",
            configuration: "Configuration",
            reports: "Reports",
            operation: "Operation",
            salonOrder: "Order Salon",
            salon: "Salon",
            waiterOrders: "Waiter Orders",
            calendars: "Calendars"
        }
    },
    es: {
        menu: {
            surveyResponses: 'Respuestas de Encuestas',
            surveys: 'Encuestas',
            userdashboard: 'Tablero de Usuarios',
            customization: 'Personalización',
            administration: 'Administración',
            products: "Productos",
            categories: "Categorias",
            ingredients: "Ingredientes",
            branches: "Sucursales",
            cashRegisters: "Cajas",
            ordersGeneral: "Pedidos general",
            orders: "Ordenes",
            kitchenOrders: "Pedidos Cocina",
            ovenOrders: "Pedidos Horno",
            deliveryOrders: "Pedidos Delivery",
            barOrders: "Pedidos mostrador",
            barAllOrders: "Todos los Pedidos",
            settings: "Ajustes",
            orderBar: "Mostrador",
            orderCashRegister: "Arqueo de caja",
            orderReport: "Resumen de caja",
            arqueoReport: "Arqueo de caja",
            restartOrder: "Reiniciar Orden",
            paymentMethods: 'Métodos de pago',
            stock: "Stock",
            stockOperation: "Operación de stock",
            stockReport: "Reporte de stock",
            stockTransactionAudit: "Auditoria de stock",
            salesReport: "Reporte de ventas",
            manage: 'Gestionar',
            zones: "Zonas",
            locations: "Ubicaciones",
            localities: "Localidades",
            maps: "Maps",
            orderState: "Mensajes de Estados",
            calendar: "Horarios",
            calendarTakeAway: "Horarios Take away",
            calendarDelivery: "Horarios Delivery",
            configuration: "Configuraciones",
            reports: "Reportes",
            operation: "Operación",
            salonOrder: "Pedidos Salon",
            salon: "Salon",
            waiterOrders: "Pedidos Camarero",
            calendars: "Calendarios"
        }
    },
    pt: {
        menu: {
            surveyResponses: 'Respostas de Pesquisas',
            surveys: 'Pesquisas',
            userdashboard: 'Painel de controle',
            customization: 'Costumização',
            administration: 'administração',
            products: "Productos",
            categories: "Categorias",
            ingredients: "Ingredientes",
            branches: "Sucursales",
            cashRegisters: "Caixas",
            ordersGeneral: "Pedidos general",
            orders: "Ordenes",
            kitchenOrders: "Pedidos Cocina",
            ovenOrders: "Orders oven",
            deliveryOrders: "Orders Delivery",
            barOrders: "Pedidos mostrador",
            settings: "Definições",
            orderBar: "Mostrador",
            orderCashRegister: "orderCashRegister",
            orderReport: "Resumen de caja",
            arqueoReport: "Arqueo de caja",
            restartOrder: "restartOrder",
            paymentMethods: 'paymentMethods',
            stock: "Stock",
            stockOperation: "Operación de Stock",
            stockReport: "Stock report",
            stockTransactionAudit: "Stock audit",
            salesReport: "Sales report",
            manage: 'manage',
            zones: "Zones",
            locations: "Locations",
            localities: "Localities",
            maps: "Maps",
            orderState: "Order States",
            calendar: "Calendar",
            calendarTakeAway: "Horarios Take away",
            calendarDelivery: "Horarios Delivery",
            configuration: "Configuration",
            reports: "Reports",
            operation: "Operation",
            salonOrder: "Order Salon",
            salon: "Salon",
            waiterOrders: "Waiter Orders",
            calendars: "Calendarios"
        }
    }
}

export default messages
